"use strict";
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var impl_1 = require("../../client/impl");
var converter_1 = require("../converter");
var extra_converter_1 = require("../extra-converter");
var model_1 = require("../model");
var primitive_converter_map_1 = require("../util/primitive-converter-map");
var generated_converter_mapping_1 = require("./generated-converter-mapping");
/**
 * Override mapping in this file
 */
exports.converterMapping = __assign({}, generated_converter_mapping_1.defaultConverterMapping, primitive_converter_map_1.PrimitiveConverterMap, {
    "string_version": impl_1.StringConverter.ascii(),
    "Array<TargetProtocol>": new extra_converter_1.TargetProtocolListConverter(),
    "Array<HostProtocol>": new converter_1.EnumListConverter(2, model_1.HostProtocol),
    "UartSettings": converter_1.UartSettingsConverterInstance,
    "ProtocolConfiguration": converter_1.ProtocolConfigurationConverterInstance
});
